export const computeBulkFlagTarget = (items, assetField) => {
  if (!items || !items.length) return false
  return items.some((item) => item && !item[assetField])
}

const ACTION_LABELS = {
  desconsiderar_rentabilidade: {
    apply: 'Desconsiderar na rentabilidade',
    revert: 'Considerar na rentabilidade',
  },
}

export const getBulkActionLabel = (assetField, willMark) => {
  const labels = ACTION_LABELS[assetField]
  if (!labels) return ''
  return willMark ? labels.apply : labels.revert
}

export const buildApplyFlagRequest = (ativos, assetField) => {
  const novoValor = computeBulkFlagTarget(ativos, assetField)
  const idsAtivos = (ativos || [])
    .map((a) => a && a.id)
    .filter((id) => id !== null && id !== undefined)
  return {
    novoValor,
    idsAtivos,
    dadosAtivo: { [assetField]: novoValor },
  }
}

export const buildEditInBatchPayload = ({
  idCliente,
  idsAtivos,
  dadosAtivo,
  isCliente,
  endpoints,
}) => {
  if (!idsAtivos || !idsAtivos.length) {
    return {
      ok: false,
      errorResponse: {
        status: 400,
        message: 'Selecione pelo menos um ativo.',
        value: null,
      },
    }
  }
  if (!isCliente && !idCliente) {
    return {
      ok: false,
      errorResponse: {
        status: 404,
        message: 'Cliente não encontrado.',
        value: null,
      },
    }
  }
  const url = isCliente
    ? endpoints.cliente.ativo
    : endpoints.profissional.ativo
  const data = {
    ids_ativos: idsAtivos,
    dados_ativo: JSON.stringify(dadosAtivo || {}),
  }
  if (!isCliente) {
    data.id_cliente_app = idCliente
  }
  return { ok: true, url, data }
}
